export enum BetTaskTypes {
    None = 0,
    NoneDescription = <any>"Sem atividade",
    Cover = 1,
    CoverDescription = <any>"Combinação de dezenas",
    Filter = 2,
    FilterDescription = <any>"Filtragem",
    Check = 3,
    CheckDescription = <any>"Conferir",
    Simulate = 4,
    SimulateDescription = <any>"Simulação",
    RandomGenerateBets = 5,
    RandomGenerateBetsDescription = <any>"Apostas aleatórias",
    ImportBets = 6,
    ImportBetsDescription = <any>"Importando aposta",
    ImportCover = 7,
    ImportCoverDescription = <any>"importando desdobramento",
    Delete = 100,
    DeleteDescription = <any>"Deletar",
    DeleteSimulate = 101,
    DeleteSimulateDescription = <any>"Remover Simulação",
    DeleteCheck = 102,
    DeleteCheckDescription = <any>"Remover Verificação",
 
}


